import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const PhotoIcon = (props) => (
  <SvgIcon
    width="70.869"
    height="57.468"
    viewBox="0 0 70.869 57.468"
    {...props}
  >
    <path d="M35.434 22.629a11.946 11.946 0 1 0 11.948 11.948 11.955 11.955 0 0 0-11.948-11.948zm31.921-9.9H55.163l-.944-10.866A1.867 1.867 0 0 0 52.352 0H18.517a1.864 1.864 0 0 0-1.865 1.863l-.945 10.861h-2.1v-2.43a1.539 1.539 0 0 0-1.541-1.538h-6.9a1.539 1.539 0 0 0-1.541 1.538v2.43h-.111A3.512 3.512 0 0 0 0 16.233v37.722a3.513 3.513 0 0 0 3.514 3.514h63.841a3.513 3.513 0 0 0 3.514-3.514V16.233a3.51 3.51 0 0 0-3.514-3.508zM8.635 27.491A4.366 4.366 0 1 1 13 23.125a4.365 4.365 0 0 1-4.365 4.366zM26.328 4.814h18.211a2.03 2.03 0 0 1 0 4.059H26.328a2.03 2.03 0 0 1 0-4.059zm9.107 47.118a17.358 17.358 0 1 1 17.357-17.356 17.358 17.358 0 0 1-17.358 17.356z" />
  </SvgIcon>
);

export default PhotoIcon;
